// カクテル名鑑のベース絞り込み。JSが無くても全件は見える（プログレッシブ）
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.w99-filter-btn');
  if (!btn) return;
  var base = btn.dataset.base;
  document.querySelectorAll('.w99-filter-btn').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
  document.querySelectorAll('.w99-cocktail').forEach(function (c) {
    c.hidden = !(base === 'all' || c.dataset.base === base);
  });
});
